import { Middleware, Context } from '@nuxt/types';

const accountManagementGuard: Middleware = (context: Context) => {
  if (!context.store.getters['user/accountManagementAllowed']) {
    context.app.router.push('/campaigns');
  }
};

export default accountManagementGuard;
